import React from 'react';
import * as chartjs from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartJSDataLabels from 'chartjs-plugin-datalabels';
import { Typography } from 'antd';

chartjs.Chart.register(ChartJSDataLabels);

interface Props {
  sensorCountByContry: any,
  t: any
}

/* eslint-disable i18next/no-literal-string */
const SensorsByArea = ({ sensorCountByContry, t }: Props) => {
  console.log(sensorCountByContry);
  const { Text } = Typography;
  const labels = Object.keys(sensorCountByContry || {}).map(label => t(label));
  const data = Object.keys(sensorCountByContry || {}).map(key => sensorCountByContry[key]);

  return (
        <>
            <div className='titleBox'>
                <Text className='titleBlackBox'>{t('ACTIVE_SENSOR_BY_AREA')}</Text>
            </div>

            <Text className='titleBlackBox'></Text>
            <div className='boxActiveSensors'>

                <div> <Bar data={{
                  labels,
                  datasets: [
                    {
                      label: t('ACTIVE_SENSOR_BY_TYPE_AND_AREA'),
                      data,
                      backgroundColor: 'rgba(255, 99, 132, 0.2)'
                    }
                  ]
                }} />
                </div>
            </div>
        </>
  );
};

export default SensorsByArea;
